import { useReducedMotion } from "framer-motion";
import "./healthHeroLoopMotion.css";

/** Clockwise orbit in 0–100 viewBox space (matches dashed ring ~inset 8–12%) */
const HERO_ORBIT_MOTION_PATH = "M 50 10 A 40 40 0 1 1 49.99 10";

const ARROW_POINTS = "0,-1.25 1.85,0 0,1.25";

/** Five arrowheads, evenly staggered (~20% of path apart) */
const ORBIT_ARROWS = [
    { dur: "32s", begin: "0s", fill: "#57C4CB", fillOpacity: 0.4 },
    { dur: "36s", begin: "-7.2s", fill: "#A2DADB", fillOpacity: 0.36 },
    { dur: "40s", begin: "-16s", fill: "#57C4CB", fillOpacity: 0.38 },
    { dur: "44s", begin: "-26.4s", fill: "#037C84", fillOpacity: 0.34 },
    { dur: "48s", begin: "-38.4s", fill: "#A2DADB", fillOpacity: 0.32 },
] as const;

const BLOB_GRADIENTS = {
    lg: "radial-gradient(circle at 38% 42%, rgba(87, 196, 203, 0.36) 0%, rgba(87, 196, 203, 0.1) 42%, transparent 72%)",
    md: "radial-gradient(circle at 62% 58%, rgba(162, 218, 219, 0.32) 0%, rgba(3, 124, 132, 0.08) 48%, transparent 74%)",
    sm: "radial-gradient(circle at 50% 50%, rgba(87, 196, 203, 0.3) 0%, rgba(162, 218, 219, 0.1) 50%, transparent 76%)",
} as const;

/**
 * Desktop-only ambient layer for the hero care-continuum diagram.
 * Floating blob lights + five orbit arrowheads — not anchored to the AIMMA hub.
 */
export function HealthHeroLoopAmbient() {
    const reducedMotion = useReducedMotion();

    if (reducedMotion) {
        return null;
    }

    return (
        <div
            className="pointer-events-none absolute inset-0 z-[1] hidden overflow-hidden lg:block"
            aria-hidden
        >
            <div className="health-hero-blob-field absolute inset-0">
                <div
                    className="health-hero-blob health-hero-blob--lg"
                    style={{ background: BLOB_GRADIENTS.lg }}
                />
                <div
                    className="health-hero-blob health-hero-blob--md"
                    style={{ background: BLOB_GRADIENTS.md }}
                />
                <div
                    className="health-hero-blob health-hero-blob--sm"
                    style={{ background: BLOB_GRADIENTS.sm }}
                />
            </div>

            <svg
                className="absolute inset-0 z-[2] h-full w-full overflow-visible"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid meet"
            >
                {ORBIT_ARROWS.map((arrow, index) => (
                    <polygon
                        key={`orbit-arrow-${index}`}
                        points={ARROW_POINTS}
                        fill={arrow.fill}
                        fillOpacity={arrow.fillOpacity}
                    >
                        <animateMotion
                            dur={arrow.dur}
                            repeatCount="indefinite"
                            begin={arrow.begin}
                            rotate="auto"
                            path={HERO_ORBIT_MOTION_PATH}
                        />
                    </polygon>
                ))}
            </svg>
        </div>
    );
}
